import React from "react";
import * as Mui from "@mui/material";
import { withStyles } from "tss-react/mui";
import type { WithStyles } from "type/tss";
import { styles } from "./style";

interface OwnProps extends Omit<Mui.CheckboxProps, "color" | "classes"> {}

interface Props extends OwnProps, WithStyles<typeof styles> {}

/**
 * A checkbox in brand orange. MUI's `color="primary"` is teal here, which is the button and link
 * color; the designs use orange for selection controls, matching the shared Switch.
 */
const Component: React.FC<Props> = ({ classes = {}, className, ...checkboxProps }) => (
	<Mui.Checkbox {...checkboxProps} color="secondary" className={[classes.root, className].filter(Boolean).join(" ")} />
);

export const BrandCheckbox = withStyles(Component, styles);
